import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';

/** Normalize stored image URLs (trim, decode entities, force https). */
export function resolveImageUrl(url) {
  if (typeof url !== 'string') return '';
  let s = url.trim().replace(/&amp;/g, '&');
  if (!s) return '';
  if (s.startsWith('//')) s = `https:${s}`;
  if (s.startsWith('http://')) s = `https://${s.slice(7)}`;
  return s;
}

/** Extract Firebase Storage object path from a download URL. */
export function parseFirebaseStoragePath(url) {
  const normalized = resolveImageUrl(url);
  if (!normalized) return null;
  try {
    const u = new URL(normalized);
    if (!u.hostname.includes('firebasestorage.googleapis.com')) return null;
    const match = u.pathname.match(/\/o\/(.+)$/);
    if (!match) return null;
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

/** Fetch a fresh download URL when a stored token is stale or invalid. */
export async function refreshFirebaseImageUrl(url) {
  const path = parseFirebaseStoragePath(url);
  if (!path) return resolveImageUrl(url);
  try {
    return await getDownloadURL(ref(storage, path));
  } catch {
    return resolveImageUrl(url);
  }
}
